ACC.paginationsort = {
  downUpKeysPressed: false,
  bindAll: function() {
    this.bindPaginationSort();
  },
  bindPaginationSort: function() {
    ACC.paginationsort.bindSortForm($('#sortForm1'));
    ACC.paginationsort.bindSortForm($('#sortForm2'));
    ACC.paginationsort.bindSortForm($('.product__list--wrapper #sortForm1'));
    ACC.paginationsort.bindSortForm($('.product__list--wrapper #sortForm2'));
    ACC.paginationsort.bindSortClick($('.search-sort-option-row'));
    ACC.paginationsort.bindResetClick($('.search-sort-heading-reset'));
  },
  bindSortClick: function(element) {
    element.click(function() {
      if ($('#sortOptions1').val() !== $(this).attr('data-val')) {
        $('#sortOptions1').val($(this).attr('data-val'));
        $('#sortForm1').submit();
      } else {
        $('.search-sort').removeClass('show');
        $('.search-sort').addClass('hidden');
        $('.search-results-cards').show();
        $('.custom-container').show();
        $('.footer').show();
      }
    });
  },
  bindResetClick: function(element) {
    element.click(function() {
      if ($('#sortOptions1').val() !== 'relevance') {
        $('#sortOptions1').val('relevance');
        $('#sortForm1').submit();
      } else {
        $('.search-sort').removeClass('show');
        $('.search-sort').addClass('hidden');
        $('.search-results-cards').show();
        $('.custom-container').show();
        $('.footer').show();
      }
    });
  },
  bindSortForm: function(sortForm) {
    sortForm.on('selectmenuchange change', function() {
      $('#loadingGif').show();
      if (!ACC.paginationsort.downUpPressed) {
        this.submit();
      }
      ACC.paginationsort.downUpPressed = false;
    });
  },
  sortFormIEFix: function(sortOptions, selectedOption) {
    sortOptions.keydown(function(e) {
      // Pressed up or down keys
      if (e.keyCode === 38 || e.keyCode === 40) {
        ACC.paginationsort.downUpPressed = true;
      }
      // Pressed enter
      else if (e.keyCode === 13 && selectedOption !== $(this).val()) {
        $(this)
          .parent()
          .submit();
      }
      // Any other key
      else {
        ACC.paginationsort.downUpPressed = false;
      }
    });
  }
};

$(document).ready(function() {
  ACC.paginationsort.bindAll();
});
